export const getActivePage = async (powerbiReport) => {
  const pages = await powerbiReport.getPages()
  return pages.find((page) => page.isActive)
}

export const findMatchingPage = async (powerbiReport, selectedPage) => {
  const pages = await powerbiReport.getPages()
  return pages.find((page) => page.displayName === selectedPage)
}

export const setActivePage = async (powerbiReport, selectedPage) => {
  const activePage = await getActivePage(powerbiReport)
  const matchingPage = await findMatchingPage(powerbiReport, selectedPage)

  if (!matchingPage && activePage) {
    return
  }

  if (matchingPage && !matchingPage.isActive) {
    matchingPage.setActive()
  }
}
